export default __webpack_public_path__ + "8f3b66ae9c43f8525cb402b6980934dc.svg";